const Colors = {
  white: '#FFFFFF',
  black: '#000000',
  navyBlue: {
    default: '#172242',
    light: '#2C3E73',
    lightest: '#F6F8FF',
  },
  orange: {
    default: '#FDA041',
  },
  blue: {
    default: '#87CEFA',
    dark: '#29A1EC',
    light: '#D7E9F5',
  },
  gray: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
  },
  red: {
    50: '#FEEAEA',
    100: '#FEE2E2',
    600: '#DC2626',
    700: '#B91C1C',
  },
  green: {
    100: '#D1FAE5',
    500: '#10B981',
    600: '#059669',
    700: '#047857',
  }
};

export default Colors;
